const doc = [({"ja":({"normal":"通常", "deleteOnSend":"送信時削除"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;